/**
 * AXIS NAMES
 * Pure rules : an axis in use needs a name, in every language of the questionnaire
 */

interface NamedAxis {
  id: string
  name?: { [language: string]: string }
}

const isFilled = (axis: NamedAxis, language: string): boolean => !!(axis.name?.[language] || "").trim()

//Axes without any name (in every language, empty or not) and axes in use named in some languages only.
//usedAxisIds : axes with at least one topic (a named empty axis is not displayed anywhere)
export function getAxisNameIssues(
  axes: NamedAxis[],
  languages: string[],
  usedAxisIds: string[]
): { unnamed: string[]; missing: { language: string; ids: string[] }[] } {
  const used = axes.filter((axis) => usedAxisIds.includes(axis.id))
  const unnamed = axes.filter((axis) => languages.every((language) => !isFilled(axis, language))).map((x) => x.id)
  const missing =
    languages.length > 1
      ? languages
          .map((language) => ({
            language,
            ids: used.filter((axis) => !unnamed.includes(axis.id) && !isFilled(axis, language)).map((x) => x.id)
          }))
          .filter((x) => x.ids.length > 0)
      : []

  return { unnamed, missing }
}
